import { action } from 'satcheljs';

/**
 * Loads suggested replies data via getItem call for Conversation view
 * @param itemId Item id to be updated with
 */

export const loadSuggestedRepliesData = action('loadSuggestedRepliesData', (itemId: string) => ({
    itemId,
}));
